import React from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

const EartagReanalysisImportTask = (props) => {
  const loopCount = props.loopCount;
  const setLoopCount = props.setLoopCount;
  const informationStyle = {
    marginLeft: 80,
    marginBottom: 20,
    paddingTop: 8,
    paddingBottom: 8,
    fontSize: 14,
    borderRadius: 10,
    width: 500,
    backgroundColor: '#EEEEEE'
  };

  return (
    <div>
      <div className={props.classes.flexContainer}
        style={informationStyle}>
        <ul>
          <li>バッチの実行回数を指定できます。</li>
          <li>指定しない場合は1回のみの実行となります。</li>
          <li>1回の実行で最大1000ファイルが処理されます。</li>
        </ul>
      </div>
      <ul className={props.classes.flexContainer} style={{marginLeft: 40, marginBottom: 20}}>
        <li>
          <InputLabel htmlFor="loop-count" style={{fontSize: 16}}>実行回数</InputLabel>
          <Select
            style={{marginTop: 5, width: 100}}
            value={loopCount}
            onChange={(e) => setLoopCount(e.target.value)}
            inputProps={{name: 'loop-count', id: 'loop-count'}}
          >
            {(() => {
              const list = [];
              for (let index = 1; index <= 10; index++) {
                list.push(<MenuItem key={`loop-count-${index}`} value={index}>{index}</MenuItem>);
              }
              return list;
            })()}
          </Select>
        </li>
      </ul>
    </div>
  );
};

EartagReanalysisImportTask.propTypes = {
  loopCount: PropTypes.number,
  setLoopCount: PropTypes.func,
  classes: PropTypes.shape({
    flexContainer: PropTypes.string
  })
};

export default EartagReanalysisImportTask;
